import React from 'react';
import { useTranslation } from 'react-i18next';

import SnapTrapStatus_0 from 'components/Icons/TrapStatus/SnapTrapStatus-0';
import SnapTrapStatus_1 from 'components/Icons/TrapStatus/SnapTrapStatus-1';
import SnapTrapStatus_2 from 'components/Icons/TrapStatus/SnapTrapStatus-2';
import SnapTrapStatus_NoSet from 'components/Icons/TrapStatus/SnapTrapStatus-no-set';
import { SnapTrapStatus } from 'api/traps/STTraps/types';

interface SnapTrapStatusCellProps {
  trapStatus: SnapTrapStatus;
  time?: string;
}

const SnapTrapStatusCell: React.FC<SnapTrapStatusCellProps> = ({ trapStatus, time }) => {
  const { t } = useTranslation();
  const title = (() => {
    switch (trapStatus) {
      case SnapTrapStatus.SET:
        return `${t('STDetail.TrapDataTableCard.statusSet')}, ${time ?? ''}`;
      case SnapTrapStatus.DARK:
        return `${t('STDetail.TrapDataTableCard.statusDark')}, ${time ?? ''}`;
      case SnapTrapStatus.TRIPPED_EMPTY:
        return `${t('STDetail.TrapDataTableCard.statusWithoutCapture')}, ${time ?? ''}`;
      case SnapTrapStatus.TRIPPED_CAUGHT:
        return `${t('STDetail.TrapDataTableCard.statusWithCapture')}, ${time ?? ''}`;
      default:
        return '-';
    }
  })();

  const Icon = (() => {
    switch (trapStatus) {
      case SnapTrapStatus.SET:
        return <SnapTrapStatus_2 />; // eslint-disable-line react/jsx-pascal-case
      case SnapTrapStatus.TRIPPED_EMPTY:
        return <SnapTrapStatus_1 />; // eslint-disable-line react/jsx-pascal-case
      case SnapTrapStatus.TRIPPED_CAUGHT:
        return <SnapTrapStatus_0 />; // eslint-disable-line react/jsx-pascal-case
      case SnapTrapStatus.NO_SET:
        return <SnapTrapStatus_NoSet />; // eslint-disable-line react/jsx-pascal-case
      default:
        return <SnapTrapStatus_NoSet />; // eslint-disable-line react/jsx-pascal-case
    }
  })();

  return <div title={title}>{Icon}</div>;
};

export default SnapTrapStatusCell;
